import React from 'react';
import { Box, Typography } from '@mui/material';

interface StatCardProps {
  number: string | number;
  label: string;
  onClick?: () => void;
  actionData?: any;
}

const StatCard: React.FC<StatCardProps> = ({ number, label, onClick, actionData }) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        textAlign: 'center',
        background: 'var(--white)',
        borderRadius: '8px',
        padding: '16px',
        minWidth: '120px',
        border: '1px solid #e0e7ff',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.3s ease',
        '&:hover': onClick ? {
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          transform: 'translateY(-2px)',
        } : {},
      }}
    >
      <Typography
        sx={{
          fontSize: '24px',
          fontWeight: 'bold',
          color: 'var(--primary-blue)',
          display: 'block',
        }}
      >
        {number}
      </Typography>
      <Typography
        sx={{
          fontSize: '12px',
          color: 'var(--dark-gray)',
          marginTop: '4px',
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default StatCard;

